var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 8.77327C12.5007 6.47209 14.3662 4.60661 16.6673 4.60661C17.1276 4.60661 17.5007 4.23351 17.5007 3.77327C17.5007 3.31304 17.1276 2.93994 16.6673 2.93994C13.4457 2.93994 10.834 5.55162 10.834 8.77327V15.2316C10.834 16.4973 11.86 17.5233 13.1257 17.5233H16.459C17.7247 17.5233 18.7507 16.4973 18.7507 15.2316V11.8983C18.7507 10.6326 17.7247 9.60661 16.459 9.60661H13.1257C12.909 9.60661 12.6993 9.63669 12.5007 9.69286V8.77327Z",
    fill: "#FF9355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50065 8.77327C2.50065 6.47209 4.36613 4.60661 6.66732 4.60661C7.12755 4.60661 7.50065 4.23351 7.50065 3.77327C7.50065 3.31304 7.12755 2.93994 6.66732 2.93994C3.44566 2.93994 0.833984 5.55162 0.833984 8.77327V15.2316C0.833984 16.4973 1.86 17.5233 3.12565 17.5233H6.45898C7.72463 17.5233 8.75065 16.4973 8.75065 15.2316V11.8983C8.75065 10.6326 7.72463 9.60661 6.45898 9.60661H3.12565C2.90898 9.60661 2.69933 9.63669 2.50065 9.69286V8.77327Z",
    fill: "#FF9355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.1fb36f0719fa9344bd789bd33e364929.svg";
export { ForwardRef as ReactComponent };